'use strict';

/* Controllers */

app.controller('SelectMoneyController', ['$scope', '$rootScope', '$location', '$timeout', 'ngDialog', 'Helper', 'User', 
    function ($scope, $rootScope, $location, $timeout, ngDialog, Helper, User) {

        // pass service to scope
        $scope.User = User;

        // init scope vars
        $scope.selected_amount = 0;
        $scope.avaliable_amounts = [10, 20, 50, 100, 200];
        $scope.selectedUser = $rootScope.globals.selectedUser;
        $scope.currency_symbol = $rootScope.globals.currentUser.credit.symbol;


        /**
         * select money amount
         * 
         * @param  Number amount
         */
        $scope.selectAmount = function(amount){
            $scope.selected_amount = amount;

            // add selected money amount to root scope
            $rootScope.globals.selectedMoney = {
                amount: $scope.selected_amount,
            }

            // remember money amount selection after browser refresh
            Helper.updateLocalStorageWithGlobalVariable();

            // redirect
            $location.path('/money-cart');
        }


        /**
         * open enter-custom-money-amount partial
         * so user can enter custom amount value
         */
        $scope.enterCustomMoneyAmount = function(){
            ngDialog.open({
                    template   : 'views/partials/enter-custom-money-amount.html',
                    controller : 'EnterCustomMoneyController',
                    className  : 'ngdialog-enter-custom-money-amount',
                    closeByNavigation : true,
                })
                .closePromise.then(function (data) {
                    if( data.value == 'submited' ){
                        // remember users selection after browser refresh
                        Helper.updateLocalStorageWithGlobalVariable();
                        
                        // redirect
                        $timeout(function(){
                            $location.path('/money-cart');
                        }, 500);
                    }
                });
        }

    }]);